//
//
//
//

import { randomRange } from '@/common/utils/common.js'
import { getPictureCode } from '@/common/api/system.js'
export default {
  data() {
    return {
      imgSrc: ''
    }
  },
  created() {
    this.handleVifyCode()
  },
  methods: {
    handleVifyCode() {
      let randomStr = randomRange(16)
      let timer = Math.floor(Date.now() / 1000)
      this.imgSrc = getPictureCode() + `?timestamp=${timer}` + randomStr
      const timestamp = timer + randomStr
      this.$emit('update', timestamp)
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/graph-vrifyCode/index.vue